import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Spacer, FormField, Flex, Label, FormHelp, Select } from '@zillow/constellation';
import React from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import FieldTooltip from './FieldTooltip.js';

function SelectField(_ref) {
  var _proxyFormState$error, _React$createElement;
  var label = _ref.label,
    required = _ref.required,
    options = _ref.options,
    name = _ref.name,
    config = _ref.config,
    description = _ref.description,
    _onChange = _ref.onChange,
    _onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    tooltip = _ref.tooltip;
  var form = useFormContext();
  var proxyFormState = useFormState();
  var error = proxyFormState === null || proxyFormState === void 0 || (_proxyFormState$error = proxyFormState.errors[name]) === null || _proxyFormState$error === void 0 ? void 0 : _proxyFormState$error.message;
  var field = form.register(name, config);
  return /*#__PURE__*/React.createElement(Spacer, {
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(FormField, (_React$createElement = {
    label: /*#__PURE__*/React.createElement(Flex, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Label, null, label), tooltip && /*#__PURE__*/React.createElement(FieldTooltip, tooltip)),
    required: required,
    description: /*#__PURE__*/React.createElement(FormHelp, {
      error: Boolean(error)
    }, error || description || /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0")),
    control: /*#__PURE__*/React.createElement(Select, _extends({
      disabled: disabled,
      error: Boolean(error)
    }, field, {
      onBlur: function onBlur(e) {
        field.onBlur(e);
        _onBlur === null || _onBlur === void 0 || _onBlur(e);
      },
      onChange: function onChange(e) {
        field.onChange(e);
        _onChange === null || _onChange === void 0 || _onChange(e);
      }
    }), placeholder && /*#__PURE__*/React.createElement("option", {
      disabled: true,
      selected: true,
      value: ""
    }, placeholder), options.map(function (option) {
      return /*#__PURE__*/React.createElement("option", {
        key: option.label,
        value: option.value
      }, option.label);
    }))
  }, _React$createElement["required"] = required, _React$createElement)));
}

export { SelectField as default };
